var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ValidationHandlerService } from '../validation-handler.service';
import { AchooInputComponent } from '../achoo-input/achoo-input.component';
import { AchooColorPickerComponent } from '../achoo-color-picker/achoo-color-picker.component';
import { ColorPickerService } from 'ngx-color-picker';
var AchooColorFieldComponent = /** @class */ (function (_super) {
    __extends(AchooColorFieldComponent, _super);
    function AchooColorFieldComponent(validationHandlerService, cpService) {
        var _this = _super.call(this, validationHandlerService) || this;
        _this.validationHandlerService = validationHandlerService;
        _this.cpService = cpService;
        _this.showColorPicker = false;
        return _this;
    }
    AchooColorFieldComponent.prototype.openColorPicker = function () {
        this.showColorPicker = true;
    };
    AchooColorFieldComponent.prototype.onClickOutside = function (evt) {
        var colorPicker = document.querySelector('#colorPickerContainer' + (this.priority || this.id));
        if (colorPicker && !colorPicker.contains(evt.target)) {
            this.color = this.colorPickerEle.originalColor;
            this.closeColorPicker();
        }
    };
    AchooColorFieldComponent.prototype.closeColorPicker = function () {
        this.showColorPicker = false;
    };
    AchooColorFieldComponent.prototype.onClickColorPicker = function () {
        if (this.showColorPicker) {
            this.closeColorPicker();
        }
        else {
            this.openColorPicker();
        }
    };
    AchooColorFieldComponent.prototype.onChangeColor = function (evt) {
        this.color = evt.color;
        var hexValue = this.convertToColorHex8(evt.color);
        if (evt.shouldClose) {
            this.onModelChange(hexValue);
            this.closeColorPicker();
        }
        else {
            this.model_ = hexValue;
        }
    };
    AchooColorFieldComponent.prototype.convertToColorHex8 = function (color) {
        var hsva = this.cpService.stringToHsva(color, true);
        if (hsva) {
            return this.cpService.outputFormat(hsva, 'hex', null);
        }
        return '';
    };
    return AchooColorFieldComponent;
}(AchooInputComponent));
export { AchooColorFieldComponent };



// WEBPACK FOOTER //
// ./src/app/core/achoo-color-field/achoo-color-field.component.ts.pre-build-optimizer.js